import { DialogBase } from '../common';
import { ModalComponent } from '../common/components/ModalDrawerContext/ModalDrawerContext';
import { FATCAController } from './FATCAController/FATCAController';

const SetupFATCAModal: ModalComponent = ({ onClose }) => {
  return (
    <DialogBase
      id="setup-fatca-modal"
      size="medium"
      onMobileFullScreen
      disableCloseButton
      visual="secondary"
      contentProps={{
        disableContentPadding: true,
      }}
    >
      <FATCAController onClose={onClose} />
    </DialogBase>
  );
};

export { SetupFATCAModal };
